var OutOfPageTypes;
(function (OutOfPageTypes) {
    OutOfPageTypes["FULLSCREEN"] = "FullScreen";
    OutOfPageTypes["MOBILE_BOTTOM"] = "MobileBottom";
})(OutOfPageTypes || (OutOfPageTypes = {}));
const BannerFromIframeToBannerType = {
    showFullscreen: OutOfPageTypes.FULLSCREEN,
    fullSreenBannerHTML5: OutOfPageTypes.FULLSCREEN,
    mobileBanner: OutOfPageTypes.MOBILE_BOTTOM,
};
var BANNER_TYPES;
(function (BANNER_TYPES) {
    BANNER_TYPES["TOP"] = "top";
    BANNER_TYPES["SIDE"] = "side";
    BANNER_TYPES["TGBM_7"] = "tgbm7";
    BANNER_TYPES["OUT_OF_PAGE"] = "outOfPage";
    BANNER_TYPES["TGB_BOTTOM"] = "tgbBottom";
})(BANNER_TYPES || (BANNER_TYPES = {}));

export { BANNER_TYPES, BannerFromIframeToBannerType, OutOfPageTypes };
//# sourceMappingURL=index.js.map
